import React, { Component } from 'react';
import WidgetModalForm, { ModalFormContext } from '../../../components/Modal/modalForm.component';
import ModalEditarDevolucao from './editarHistoricoDACADevolucao/editarHistoricoDacaDevolucao.modal';
import ModalEditarHistoricoEntrada from './editarHistoricoDACAEntrada/editarHistoricoDacaEntrada.modal';
import ModalEditarHistoricoMovimentacao from './editarHistoricoDACAMovimentacao/editarHistoricoDacaMovimentacao.modal';
import ModalEditarHistoricoSaida from './editarHistoricoDACASaida/editarHistoricoDacaSaida.modal';
import ModalEditarHistoricoSaidaPermanente from './editarHistoricoDACASaida/editarHistoricoDacaSaidaPermanente.modal';

export default class ModalEditarHistoricoDaca extends Component {
	/* Modal de Edição do item Daca */
	constructor(props) {
		super(props);
		this.state = {
			validationSchema: {},
		};
		this.columns = [];
		this.actions = [];
	}

	/* Define o schema de validação a ser usado no submit do formulário */
	handleValidationSchema = (schema) => {
		this.setState({
			validationSchema: schema,
		});
	}

	getModalTitle = (tipoTransacao) => {
		switch (tipoTransacao) {
		case 'ENTRADA':
			return 'entrada';
		case 'SAIDA':
			return 'saída';
		case 'MOVIMENTACAO':
			return 'movimentação de estoque';
		case 'DEVOLUCAO':
			return 'devolução';
		case 'DESCARTE':
			return 'descarte';
		default:
			return '-';
		}
	}

	render() {
		const {
			props: {
				isOpenEditarTransacao,
				handleCloseEditarTransacao,
				handleSubimitEditarTransacao,
				transacao,
				idDaca,
				daca,
			},
			state: {
				validationSchema,
			},
		} = this;
		return (
			<WidgetModalForm
				initialValues={transacao}
				validationSchema={validationSchema}
				iconCancelar='fas fa-times'
				textCancelar='Cancelar'
				textConfirmar='Salvar'
				iconConfirmar='fas fa-save'
				title={`Editar ${this.getModalTitle(transacao.tipoTransacao)}`}
				isOpen={isOpenEditarTransacao}
				cancelar={handleCloseEditarTransacao}
				confirmar={(values) => {
					const dados = values;
					if (dados.destinoEstoque && dados.destinoEstoque.empresa) {
						dados.destinoEstoque.empresa.telefonePrincipal = dados.destinoEstoque
							.empresa.telefonePrincipal.replace(
								/\D/g,
								'',
							);
						dados.destinoEstoque.empresa.telefoneSecundario = dados.destinoEstoque
							.empresa.telefoneSecundario.replace(
								/\D/g,
								'',
							);
					}

					if (dados.destinoEstoque && dados.destinoEstoque.tipoEstoque === 'COMPRA_EMERGENCIAL') {
						dados.destinoEstoque.numero = dados.destinoEstoque.numero.replace(/[^\d]/g, '');
					}

					if (dados.destinoEstoque && dados.destinoEstoque.tipoEstoque === 'ESTOQUE_DACA') {
						dados.destinoEstoque.empresa = null;
					}

					if (dados.destinoEstoque
						&& dados.destinoEstoque.tipoEstoque === 'ARP'
						&& dados.destinoEstoque.numero
						&& dados.destinoEstoque.numero.length > 9) {
						dados.destinoEstoque.numero = dados.destinoEstoque.numero.substring(0, 9);
					}

					handleSubimitEditarTransacao(dados);
				}}
				tamanho='lg'
				isEditarTransacao
				dataAlteracao={transacao.dataAlteracao}
				modalConfirmarFechar
				modalConfirmarCancelar
				modalConfirmarCancelarTitulo='Atenção!'
				modalConfirmarCancelarCorpo='Tem certeza que deseja cancelar? Todos os dados preenchidos serão perdidos.'
			>
				<ModalFormContext.Consumer>
					{({
						values,
						handleChange,
						setFieldValue,
						resetForm,
					}) => (
						<React.Fragment>
							<div className='row'>
								<div className='col-md-12'>
									{/* Corpo da modal de editar transação de entrada */}
									{values.tipoTransacao !== null && values.tipoTransacao === 'ENTRADA' && (
										<ModalEditarHistoricoEntrada
											transacao={values}
											handleChange={handleChange}
											setFieldValue={setFieldValue}
											handleValidationSchema={(e) => {
												this.handleValidationSchema(e);
											}}
										/>
									)}

									{/* Corpo da modal de editar transação de saida para bens de consumo */}
									{daca.permanente === false && values.tipoTransacao !== null && values.tipoTransacao === 'SAIDA' && (
										<ModalEditarHistoricoSaida
											transacao={values}
											handleChange={handleChange}
											setFieldValue={setFieldValue}
											idDaca={idDaca}
											handleValidationSchema={(e) => {
												resetForm(values);
												this.handleValidationSchema(e);
											}}
										/>
									)}

									{/* Corpo da modal de editar transação de saida para material permanente */}
									{daca.permanente === true && values.tipoTransacao !== null && (values.tipoTransacao === 'SAIDA' || values.tipoTransacao === 'DESCARTE') && (
										<ModalEditarHistoricoSaidaPermanente
											transacao={values}
											handleChange={handleChange}
											setFieldValue={setFieldValue}
											idDaca={idDaca}
											handleValidationSchema={(e) => {
												resetForm(values);
												this.handleValidationSchema(e);
											}}
										/>
									)}

									{/* Corpo da modal de editar transação de movimentacao */}
									{values.tipoTransacao !== null && values.tipoTransacao === 'MOVIMENTACAO' && (
										<React.Fragment>
											<ModalEditarHistoricoMovimentacao
												transacao={values}
												handleChange={handleChange}
												setFieldValue={setFieldValue}
												idDaca={idDaca}
												handleValidationSchema={(e) => {
													resetForm(values);
													this.handleValidationSchema(e);
												}}
											/>
										</React.Fragment>
									)}

									{/* Corpo da modal de editar transação de devolução */}
									{values.tipoTransacao !== null && values.tipoTransacao === 'DEVOLUCAO' && (
										<ModalEditarDevolucao
											transacao={values}
											handleChange={handleChange}
											setFieldValue={setFieldValue}
											idDaca={daca.id}
											handleValidationSchema={(e) => {
												resetForm(values);
												this.handleValidationSchema(e);
											}}
										/>
									)}
								</div> {/* col-md-12 pl-0 pr-0 */}
							</div> {/* .row */}
						</React.Fragment>
					)}
				</ModalFormContext.Consumer>
			</WidgetModalForm>
		);
	}
}
